/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { AMFileListContainer } from './container';
import { useNavigate } from "react-router-dom";

export const AMFileListPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  console.log('CampaignListPage', navigation);
  return <AMFileListContainer onViewClick={() => {
    navigate(`/amfile-details`)
  }} />;
};
